import { render, staticRenderFns } from "./Vimeo.vue?vue&type=template&id=203c2c36&scoped=true&lang=pug&"
import script from "./Vimeo.vue?vue&type=script&lang=js&"
export * from "./Vimeo.vue?vue&type=script&lang=js&"
import style0 from "./Vimeo.vue?vue&type=style&index=0&id=203c2c36&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203c2c36",
  null
  
)

export default component.exports